import { type RouteObject } from 'react-router'
import { lazy } from 'react'

/**
 * Creates routes for request magic link feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: 'request-magic-link',
      Component: lazy(
        () => import('@/features/iam/magic-link/RequestMagicLinkView/'),
      ),
    },
  ]
}
